import { applyMiddleware, createStore, type Middleware } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { createEpicMiddleware, type Epic } from 'redux-observable';
import { debugEnabled } from '@atlassian/jira-common-debug/src/index.tsx';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import type { Action } from './actions/types.tsx';
import reducer from './reducer.tsx';
import type { State } from './types.tsx';

const createStore1 = (rootOperation: Epic<Action, State>, name: string) => {
	const middlewares: Array<Middleware> = [];

	if (debugEnabled('redux-logger')) {
		// include logger only for development environment
		// eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
		const { logger } = require('redux-logger');
		middlewares.push(logger);
	}

	return createStore(
		enableBatching(reducer), // initial state
		undefined,
		composeWithDevtools({ name: `Delete component '${name}'` })(
			applyMiddleware(...middlewares, createEpicMiddleware(rootOperation)),
		),
	);
};

export default createStore1;
